module.exports = __webpack_public_path__ + "img/03jigou.718d64e1.png";